import React, { useEffect, useRef, useState } from 'react';
import styles from './ScheduledStoryInfo.module.scss';
import CloseButton from 'engage/components/CloseButton/CloseButton';
import VideoService from 'engage/service/VideoService';
import Avatar from 'engage/components/Avatar/Avatar';
import { CustomButton } from 'engage/components/Button/Button';
import { parseString } from 'engage/utils/stringHelper';
import { useTranslation } from 'react-i18next';
import UsersListPreview from 'engage/components/UsersListPreview/UsersListPreview';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import * as Sentry from '@sentry/browser';

const ScheduledStoryInfo = ({ story, handleEditEvent, onClose }) => {
    const [loadingAssignments, setLoadingAssignments] = useState(false);
    const [usersList, setUsersList] = useState([]);
    const abortControllerRef = useRef(null);

    const { t } = useTranslation();
    const history = useHistory();

    useEffect(() => {

        const loadAssignments = async () => {
            try {
                setLoadingAssignments(true);
                abortControllerRef.current = new AbortController();
                const assignmentsList = await VideoService.getVideoAssignmentsList(story?.id, abortControllerRef.current.signal);
                setUsersList(assignmentsList.map(item => item.assigned));
                abortControllerRef.current = null;
            } catch (e) {
                Sentry.captureException(e);
                console.error('Error while loading assignments', e);
            } finally {
                setLoadingAssignments(false);
            };
        };

        loadAssignments();

        return () => {
            if (loadingAssignments) {
                abortControllerRef?.current?.abort();
            }
        }
    }, []);

    return <>
        <div className={styles.eventDetailsHeader}>
            <span className={styles.title}>{story?.name}</span>
            <CloseButton className={styles.closeBtn} onClose={onClose} />
        </div>
        <div className={styles.storyInfo}>
            {story?.author ? <div className={styles.profile}>
                <Avatar image={story?.author?.avatar} size="medium" className={styles.avatar} title={story?.author?.name} alt={`Video's owner avatar`} />
                {story?.author?.name && (
                    <span className={styles.userName}>{`${t('my_video.by')} ${parseString(story?.author.name)}`}</span>
                )}
            </div> : null}
            {story?.updatedAt ? <div className={styles.postInfo}>
                <span>{`${t('my_video.last_update')} ${t('general.date', {
                    date: new Date(`${story?.updatedAt}`),
                })}`}</span>
            </div> : null}
        </div>
        {usersList.length ? <div className={styles.teamContainer}>
            <span className={styles.teamText}>{t('storyboard.editor.team')}</span>
            <UsersListPreview parentRef={parent} users={usersList} className={styles.usersList} />
        </div> : null}
        {story?.description ? <span className={styles.description}>{story?.description}</span> : null}
        <div className={styles.eventDetailsContent}>
            <CustomButton label={t('schedule.calendar.edit_video')} variant='primary' onClick={() => history.push(`/eg/storyboard/${story.id}`)} />
            <CustomButton label={t('storyboard.editor.schedule.change')} variant='secondary' onClick={handleEditEvent} />
        </div>
    </>;
}

export default ScheduledStoryInfo;